<template>
  <loading
    v-model:active="isLoading"
    :can-cancel="false"
    :is-full-page="fullScreen"
    :background-color="backgroundColor"
  ></loading>
</template>

<script>
import { defineComponent } from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default defineComponent({
  name: "LoadingOverlay",
  props: {
    isLoading: {
      type: Boolean,
      required: true,
      default: false,
    },
    fullScreen: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      backgroundColor: "#f8f8f8",
    };
  },
  components: {
    Loading,
  },
});
</script>
